import React from "react"
import styled from "styled-components"

import Typography from "@material-ui/core/Typography"

import ImageView from "./../../imageView"
import { ImageBlock } from "./../../imageView/ImageView"

const ProductGallery = ({ headline, subline, gallery }) => {
  return (
    <Container>
      {!!headline && (
        <Headline variant="h2" gutterBottom>
          {headline}
        </Headline>
      )}
      {!!subline && <Subline variant="body1">{subline}</Subline>}

      {!!gallery && (
        <Gallery>
          <ImageView images={gallery} />
          <ImageBlock
            style={{
              paddingBottom: 0,
              margin: 0,
              height: 0,
              minHeight: 0
            }}
          />
          <ImageBlock
            style={{
              paddingBottom: 0,
              margin: 0,
              height: 0,
              minHeight: 0
            }}
          />
          <ImageBlock
            style={{
              paddingBottom: 0,
              margin: 0,
              height: 0,
              minHeight: 0
            }}
          />
        </Gallery>
      )}
    </Container>
  )
}
export default ProductGallery

const Container = styled.div`
  padding-bottom: 60px;
`
const Headline = styled(Typography)`
  text-transform: uppercase;
`
const Subline = styled(Typography)``

const Gallery = styled.div`
  padding: 30px 0;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: flex-start;
  > div {
    margin-bottom: 10px;
    @media (min-width: 800px) {
      width: calc(100% / 3 - 5px);
    }
    @media (max-width: 799px) {
      width: calc(100% / 2 - 5px);
    }
  }
`
